<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper" class="page">
      <div id="employee_fluid" class="container-fluid">
        <b-form autocomplete="off" @submit.prevent="storeItem">
          <div class="mb-4">
            <a href="#" @click.prevent="goBack">
              <i class="fas fa-arrow-left"></i>
              Back to Employee Profile
              <!-- trở về danh sách nhân sự -->
            </a>
            <div class="float-right">
              <button class="btn btn-primary" type="submit">
                Save
                <!-- Lưu -->
              </button>
            </div>
          </div>
          <b-card class="mt-4">
            <b-form-row>
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Employee Picture
                    <!-- Ảnh nhân viên -->
                  </template>
                  <div v-if="thong_tin_chung.anhnhanvien == null">
                    <i class="fas fa-user"></i>
                  </div>
                  <div v-else>
                    <img
                      :src="thong_tin_chung.anhnhanvienpath"
                      style="max-width: 150px;"
                    />
                  </div>
                  <a
                    v-if="thong_tin_chung.anhnhanvien == null"
                    href="#"
                    @click.prevent="uploadImageShow = true"
                    >Choose Picture
                    <!-- Chọn ảnh -->
                  </a>
                  <a v-else href="#" @click.prevent="clearItemImage">Xóa ảnh</a>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                class="form-inline"
                style="padding-left:70px; padding-right:15px;"
                align-self="start"
              >
                <div style="flex-grow: 1" />
                <!-- <button class="btn btn-info" @click.prevent="updateItem">
                  <i class="fas fa-save mr-2"></i>
                  Save General Information
                </button> -->
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Email
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model="thong_tin_chung.email"
                    type="email"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Employee ID
                    <!-- Mã nhân viên -->
                    <span class="text-danger">*</span>
                  </template>
                  <div class="form-inline">
                    <b-form-input
                      v-model="thong_tin_chung.manhanvien"
                      style="width: calc(100% - 40px);"
                    ></b-form-input>
                    <button
                      class="btn btn-secondary"
                      id="popover-target-1"
                      @click.prevent=""
                    >
                      <i class="fa fa-copy" style="size: 200%"></i>
                    </button>
                  </div>
                  <b-popover target="popover-target-1" triggers="click blur">
                    <template v-slot:title>
                      Select Department Code
                      <!-- Chọn mã phòng ban -->
                    </template>
                    <b-form-select
                      v-model="departmentCode"
                      :options="departments"
                      value-field="id"
                      text-field="tendonvi"
                      @change="autogenerateUserCode"
                    >
                    </b-form-select>
                  </b-popover>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Name
                    <!-- Họ và tên -->
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model="thong_tin_chung.hovaten"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    English Name
                    <!-- Tên tiếng anh -->
                  </template>
                  <b-form-input
                    v-model="thong_tin_chung.tentienganh"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Gender
                    <!-- Giới tính -->
                  </template>
                  <b-form-select
                    v-model="thong_tin_chung.gioitinh"
                    :options="gioitinhs"
                    value-field="text"
                    text-field="text"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label-cols="3" style="margin-bottom: 0;">
                  <template v-slot:label>
                    Date of birth
                    <!-- Ngày sinh -->
                  </template>
                  <my-date-picker v-model="ngaysinh_selected"></my-date-picker>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Place of birth
                    <!-- Nơi sinh -->
                  </template>
                  <b-form-input
                    v-model="thong_tin_chung.noisinh"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="12">
                  <template v-slot:label>
                    <div class="form-inline">
                      <b class="mr-4">
                        Line Manager
                        <!-- Line Manager -->
                      </b>
                      <b-form-checkbox
                        v-model="noLinemanager"
                        @change="changeLinemanager"
                      >
                        Create employees without line managers
                      </b-form-checkbox>
                    </div>
                  </template>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Name
                    <span class="text-danger" v-if="lineManagerEnabled">*</span>
                    <!-- Line manager -->
                  </template>
                  <multiselect
                    v-model="linemanager_selected"
                    placeholder
                    track-by="id"
                    label="hovaten"
                    selectedLabel="are selecting"
                    select-label="Enter to select"
                    deselectLabel="Enter to remove"
                    :disabled="!lineManagerEnabled"
                    :searchable="true"
                    :options="employees"
                    @select="unlockLineManager"
                    @remove="lockLineManager"
                  >
                  </multiselect>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    CC email
                  </template>
                  <b-form-input
                    v-model="employee_group.ccemail"
                    :disabled="!ccEmailEnabled"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                style="padding-left:70px; padding-right:15px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Working Status
                    <!-- Trạng thái -->
                  </template>
                  <b-form-select
                    v-model="thong_tin_chung.tinhtranghoso"
                    :options="tinhtranghosos"
                    value-field="id"
                    text-field="pickListValue"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    National
                    <!-- Dân tộc -->
                  </template>
                  <div class="form-inline">
                    <b-form-select
                      style="width:100%"
                      v-model="thong_tin_chung.dantoc"
                      :options="dantocs"
                      value-field="id"
                      text-field="pickListValue"
                    ></b-form-select>
                  </div>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Religion
                    <!-- Tôn giáo -->
                  </template>
                  <div class="form-inline">
                    <b-form-select
                      style="width:100%"
                      v-model="thong_tin_chung.tongiao"
                      :options="tongiaos"
                      value-field="id"
                      text-field="pickListValue"
                    />
                  </div>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Nationality
                    <!-- Quốc tịch -->
                  </template>
                  <div class="form-inline">
                    <b-form-select
                      style="width:calc(100% - 42px);"
                      v-model="thong_tin_chung.quoctich"
                      :options="quoctichsUsed"
                      value-field="id"
                      text-field="pickListValue"
                    />
                    <button class="btn" @click.prevent="openModal">
                      <i class="fas fa-table"></i>
                    </button>
                  </div>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="12">
                  <template v-slot:label>
                    <b>
                      PIT, SSI, Bank Info
                      <!-- Tài khoản -->
                    </b>
                  </template>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    PIT code
                    <!-- MST cá nhân -->
                  </template>
                  <b-form-input
                    v-model="thong_tin_chung.mstcanhan"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Social Insurance Book No.
                    <!-- Số BHXH -->
                  </template>
                  <b-form-input v-model="thong_tin_chung.sobhxh"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Bank Account No.
                    <!-- Số tài khoản NH -->
                  </template>
                  <b-form-input
                    v-model="thong_tin_chung.sotaikhoannganhang"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Bank
                    <!-- Ngân hàng -->
                  </template>
                  <!-- <b-form-input v-model="thong_tin_chung.nganhang"></b-form-input> -->
                  <b-form-select
                    v-model="thong_tin_chung.nganhang"
                    text-field="name"
                    value-field="name"
                    :options="banks"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Bank Branch
                    <!-- Chi nhánh -->
                  </template>
                  <b-form-input
                    v-model="thong_tin_chung.chinhanh"
                  ></b-form-input>
                </b-form-group>
                <span style="padding-left: 5px; font-weight: 500;"
                  >Initiaing Facility Registration</span
                >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    City
                    <!-- Thành phố -->
                  </template>
                  <multiselect
                    v-model="hopital_city_selected"
                    placeholder
                    track-by="id"
                    label="name"
                    selectedLabel="are selecting"
                    select-label="Enter to select"
                    deselectLabel="Enter to remove"
                    :searchable="true"
                    :options="hopitalCityProvinces"
                    @select="unlockHopitalCity"
                    @remove="lockHopitalCity"
                  >
                  </multiselect>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Hopital Branch
                    <!-- Chi nhánh -->
                  </template>
                  <b-form-input
                    v-model="thong_tin_chung.hopitalBranch"
                    :disabled="!hopitalBranchEnabled"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="0" md="1" /> -->
              <b-col
                cols="12"
                md="6"
                style="padding-left:70px; padding-right:15px;"
              >
                <b-form-group label-cols="12">
                  <template v-slot:label>
                    <b>
                      ID Card/Passport
                      <!-- CMND/Thẻ căn cước/Hộ chiếu -->
                    </b>
                  </template>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    ID/Passport No.
                    <!-- Số -->
                  </template>
                  <b-form-input v-model="thong_tin_chung.cmndso"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="3" style="margin-bottom: 0;">
                  <template v-slot:label>
                    Issued Date
                    <!-- Ngày cấp -->
                  </template>
                  <my-date-picker
                    v-model="cmndngaycap_selected"
                  ></my-date-picker>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Issued Place
                    <!-- Nơi cấp -->
                  </template>
                  <b-form-input
                    v-model="thong_tin_chung.cmndnoicap"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="3" style="margin-bottom: 0;">
                  <template v-slot:label>
                    Expired Date
                    <!-- Ngày hết hạn -->
                  </template>
                  <my-date-picker
                    v-model="cmndngayhethan_selected"
                  ></my-date-picker>
                </b-form-group>
              </b-col>
            </b-form-row>
            <!-- THONG TIN LIEN HE -->
            <!-- <b-form-row>
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Phone Number -->
            <!-- ĐT di động -->
            <!-- </template>
                  <b-form-input
                    v-model="thong_tin_lien_he.dtdidong"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                class="form-inline"
                style="padding-left:70px; padding-right:15px;"
                v-if="item"
                align-self="start"
              >
                <div style="flex-grow: 1" />
                <button class="btn btn-info">
                  <i class="fas fa-save mr-2"></i>
                  Save Contact Information -->
            <!-- Lưu thông tin liên hệ -->
            <!-- </button>
              </b-col>
            </b-form-row> -->
            <b-form-row>
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="12">
                  <template v-slot:label>
                    <b>
                      Place of birth
                      <!-- Hộ khẩu thường trú -->
                    </b>
                  </template>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="0" md="1" /> -->
              <b-col
                cols="12"
                md="6"
                style="padding-left:70px; padding-right:15px;"
              >
                <b-form-group label-cols="12">
                  <template v-slot:label>
                    <div class="form-inline">
                      <b class="mr-4">
                        Contact address
                        <!-- Chỗ ở hiện nay -->
                      </b>
                      <b-form-checkbox
                        v-model="cbx_hien_nay_giong_ho_khau"
                        @change="copySlot"
                      >
                        Same as Permanent Residence
                        <!-- Giống hộ khẩu thường trú -->
                      </b-form-checkbox>
                    </div>
                  </template>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col
                cols="12"
                md="6"
                style="padding-left:15px; padding-right:70px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    City
                    <!-- Thành phố -->
                  </template>
                  <multiselect
                    v-model="hokhau_tinhthanhpho_selected"
                    placeholder
                    track-by="id"
                    label="name"
                    selectedLabel="Đang chọn"
                    select-label="Enter để chọn"
                    deselectLabel="Enter để xóa"
                    :searchable="true"
                    :options="provinces"
                    @select="unlockDistrict"
                    @remove="lockDistrictAndWard"
                  >
                  </multiselect>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    District
                    <!-- Quận/Huyện -->
                  </template>
                  <!-- <b-form-input v-model="thong_tin_lien_he.hokhau_quanhuyen" ></b-form-input>  -->
                  <multiselect
                    v-model="hokhau_quanhuyen_selected"
                    placeholder
                    track-by="id"
                    label="name"
                    selectedLabel="Đang chọn"
                    select-label="Enter để chọn"
                    deselectLabel="Enter để xóa"
                    :searchable="true"
                    :options="districts"
                    @select="unlockWard"
                    @remove="lockWard"
                    :disabled="!districtEnabled"
                  >
                  </multiselect>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Ward
                    <!-- Xã/Phường -->
                  </template>
                  <!-- <b-form-input v-model="thong_tin_lien_he.hokhau_xaphuong"  ></b-form-input>         -->
                  <multiselect
                    v-model="hokhau_xaphuong_selected"
                    placeholder
                    track-by="id"
                    label="name"
                    selectedLabel="Đang chọn"
                    select-label="Enter để chọn"
                    deselectLabel="Enter để xóa"
                    :searchable="true"
                    :options="wards"
                    :disabled="!wardEnabled"
                  >
                  </multiselect>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Address
                    <!-- Số nhà, đường -->
                  </template>
                  <b-form-input
                    v-model="thong_tin_lien_he.hokhau_sonha"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Phone Number
                    <!-- ĐT di động -->
                  </template>
                  <b-form-input
                    v-model="thong_tin_lien_he.dtdidong"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="0" md="1" /> -->
              <b-col
                cols="12"
                md="6"
                style="padding-left:70px; padding-right:15px;"
              >
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    City
                    <!-- Thành phố -->
                  </template>
                  <!-- <b-form-input v-model="thong_tin_lien_he.hiennay_tinhthanhpho" ></b-form-input> -->
                  <multiselect
                    v-model="hiennay_tinhthanhpho_selected"
                    placeholder
                    track-by="id"
                    label="name"
                    selectedLabel="Đang chọn"
                    select-label="Enter để chọn"
                    deselectLabel="Enter để xóa"
                    :searchable="true"
                    :options="hiennay_provinces"
                    @select="unlockDistrict_hiennay"
                    @remove="lockDistrictAndWard_hiennay"
                    :disabled="cbx_hien_nay_giong_ho_khau"
                  >
                  </multiselect>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    District
                    <!-- Quận/Huyện -->
                  </template>
                  <!-- <b-form-input v-model="thong_tin_lien_he.hiennay_quanhuyen" ></b-form-input> -->
                  <multiselect
                    v-model="hiennay_quanhuyen_selected"
                    placeholder
                    track-by="id"
                    label="name"
                    selectedLabel="Đang chọn"
                    select-label="Enter để chọn"
                    deselectLabel="Enter để xóa"
                    :searchable="true"
                    :options="hiennay_districts"
                    @select="unlockWard_hiennay"
                    @remove="lockWard_hiennay"
                    :disabled="
                      !hiennay_districtEnabled || cbx_hien_nay_giong_ho_khau
                    "
                  >
                  </multiselect>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Ward
                    <!-- Xã/Phường -->
                  </template>
                  <!-- <b-form-input v-model="thong_tin_lien_he.hiennay_xaphuong"></b-form-input>         -->
                  <multiselect
                    v-model="hiennay_xaphuong_selected"
                    placeholder
                    track-by="id"
                    label="name"
                    selectedLabel="Đang chọn"
                    select-label="Enter để chọn"
                    deselectLabel="Enter để xóa"
                    :searchable="true"
                    :options="hiennay_wards"
                    :disabled="
                      !hiennay_wardEnabled || cbx_hien_nay_giong_ho_khau
                    "
                  >
                  </multiselect>
                </b-form-group>
                <b-form-group label-cols="3">
                  <template v-slot:label>
                    Address
                    <!-- Số nhà, đường -->
                  </template>
                  <b-form-input
                    v-model="thong_tin_lien_he.hiennay_sonha"
                    :disabled="cbx_hien_nay_giong_ho_khau"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-card>

          <!-- UPLOAD IMAGE MODAL -->
          <b-modal
            v-model="uploadImageShow"
            header-bg-variant="info"
            header-text-variant="light"
            hide-footer
          >
            <template v-slot:modal-title>
              Choose Picture
              <!-- Chọn ảnh -->
            </template>
            <div class="d-block text-center">
              <div>
                <!-- <img v-if="isImageUploading == true" src="../../assets/loading.gif" /> -->
                <b-card v-if="isImageUploading == false" no-body>
                  <div class="text-center p-2">
                    <label for="uploadFile" style="width: 100%;">
                      <h4 class="pt-2">
                        Click here to upload photo
                        <!-- Nhấn vào đây để tải ảnh. -->
                        <br />
                        or
                        <!-- hoặc -->
                      </h4>
                      <span
                        class="btn btn-primary file-uploads file-uploads-html5 file-uploads-drop"
                      >
                        <!-- Chọn tập tin -->
                        Select file
                        <label for="uploadFile"></label>
                        <input
                          type="file"
                          name="uploadFile"
                          id="uploadFile"
                          accept="image/*"
                          @change="
                            fileChange($event.target.name, $event.target.files)
                          "
                        />
                      </span>
                    </label>
                  </div>
                </b-card>
              </div>
            </div>
          </b-modal>
          <!-- END OF UPLOAD IMAGE MODAL -->

          <!-- PICKLIST MODAL -->
          <b-modal
            v-model="modalShow"
            header-bg-variant="info"
            header-text-variant="light"
          >
            <template v-slot:modal-footer="{ cancel }">
              <b-button variant="secondary" @click="cancel()">
                <i class="fas fa-times mr-2"></i>
                Close
                <!-- Đóng -->
              </b-button>
            </template>
            <button class="btn btn-info mb-2" @click.prevent="openChildModal">
              <i class="fas fa-plus"></i>
              Add
              <!-- Thêm -->
            </button>
            <b-table
              bordered
              head-variant="dark"
              hover
              responsive
              :fields="fields"
              :items="modalItems"
            >
              <template v-slot:cell(pickListValue)="data">
                <input
                  type="text"
                  class="form-control"
                  :value="data.item.pickListValue"
                  required
                  @change="updateModalItem(data, $event)"
                />
              </template>
              <template v-slot:cell(used)="data">
                <input
                  type="checkbox"
                  v-model="data.item.used"
                  @change.prevent="updateUsedModalItem(data)"
                />
              </template>
            </b-table>
          </b-modal>
          <b-modal
            v-model="childModalShow"
            @ok="storeModalItem"
            header-bg-variant="info"
            header-text-variant="light"
          >
            <template v-slot:modal-footer="{ ok, cancel }">
              <b-button variant="info" @click="ok()"
                ><i class="fas fa-save mr-2"></i>
                Save
                <!-- Lưu -->
              </b-button>
              <b-button variant="secondary" @click="cancel()"
                ><i class="fas fa-times mr-2"></i>
                Close
                <!-- Đóng -->
              </b-button>
            </template>
            <b-container>
              <b-row class="mb-4">
                <b-col cols="4">
                  <label class="mr-2">Tên</label>
                  <code>*</code>
                </b-col>
                <b-col cols="8">
                  <b-form-input v-model="itemModalName" required></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4"></b-col>
                <b-col cols="8">
                  <b-form-checkbox v-model="itemModalUsed"
                    >Được sử dụng</b-form-checkbox
                  >
                </b-col>
              </b-row>
            </b-container>
          </b-modal>
          <!-- END OF PICKLIST MODAL -->
          <!-- <pickup-list-modal :items="modalItems" :type="modalType" :show="show" v-on:modalOk="modalOk" v-on:modalCancel="modalCancel"/> -->
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import MyDatePicker from "../components/App/MyDatePicker";

export default {
  name: "Employee",
  components: {
    Multiselect,
    MyDatePicker,
  },
  data() {
    return {
      thong_tin_chung: {
        userid: 0,
        anhnhanvien: null,
        email: null,
        manhanvien: null,
        hovaten: null,
        tentienganh: null,
        // gioitinh: "Nam",
        gioitinh: "Male",
        ngaysinh: "",
        noisinh: null,
        tinhtranglamviec: null,
        hopitalCity: null,
        hopitalBranch: null,
        donvicongtac: null,
        vitricongviec: null,
        ngaythuviec: null,
        ngaychinhthuc: null,
        dantoc: null,
        tongiao: null,
        quoctich: null,
        mstcanhan: null,
        sobhxh: null,
        sotaikhoannganhang: null,
        nganhang: null,
        chinhanh: null,
        cmndso: null,
        cmndngaycap: "",
        cmndnoicap: null,
        cmndngayhethan: "",
        tinhtranghoso: null,
        salt: "test",
        password: "test",
      },

      thong_tin_lien_he: {
        id: 0,
        employeeid: 0,
        dtdidong: null,
        hokhau_tinhthanhpho: null,
        hokhau_quanhuyen: null,
        hokhau_xaphuong: null,
        hokhau_sonha: null,
        hiennay_tinhthanhpho: null,
        hiennay_quanhuyen: null,
        hiennay_xaphuong: null,
        hiennay_sonha: null,
      },

      employee_group: {
        id: 0,
        employeeid: 0,
        employeeid2: null,
        groupid: 138,
        ccemail: null,
      },

      departmentCode: -1,
      employees: [],

      gioitinhs: [
        { value: 1, text: "Male" },
        { value: 2, text: "Female" },
        // { value: 1, text: "Nam" },
        // { value: 2, text: "Nữ" },
      ],
      dantocs: [],
      tongiaos: [],
      quoctichs: [],
      quanhes: [],
      departments: [],
      provinces: [],
      districts: [],
      wards: [],
      banks: [],

      hopitalCityProvinces: [],
      hopitalCityDistricts: [],

      hopitalBranchEnabled: false,
      ccEmailEnabled: false,
      lineManagerEnabled: true,
      noLinemanager: false,

      hopital_city_selected: null,
      linemanager_selected: null,
      linemanager_temp_selected: null,

      districtEnabled: false,
      wardEnabled: false,
      hokhau_tinhthanhpho_selected: null,
      hokhau_quanhuyen_selected: null,
      hokhau_xaphuong_selected: null,

      hiennay_provinces: [],
      hiennay_districts: [],
      hiennay_wards: [],

      hiennay_provinceEnabled: false,
      hiennay_districtEnabled: false,
      hiennay_wardEnabled: false,
      hiennay_tinhthanhpho_selected: null,
      hiennay_quanhuyen_selected: null,
      hiennay_xaphuong_selected: null,

      cbx_hien_nay_giong_ho_khau: false,

      fields: [
        {
          key: "pickListValue",
          label: "Tên",
        },
        {
          key: "used",
          label: "Sử dụng",
          thStyle: { width: "100px !important" },
        },
      ],

      modalItems: [],
      modalShow: false,
      childModalShow: false,
      itemModalName: null,
      itemModalUsed: false,
      tinhtranghosos: [],

      ngaysinh_selected: "",
      cmndngaycap_selected: "",
      cmndngayhethan_selected: "",

      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },

      //Upload ảnh
      uploadImageShow: false,
      isImageUploading: false,
    };
  },

  watch: {
    linemanager_selected: function(newValue, oldValue) {
      if (newValue != null) {
        if (this.employee_group.ccemail == null)
          this.employee_group.ccemail = "hr@megroup.asia";
        this.employee_group.employeeid2 = newValue.id;
      } else {
        this.employee_group.employeeid2 = null;
        this.employee_group.ccemail = null;
      }
    },
  },

  computed: {
    quoctichsUsed() {
      const null_value = {
        id: null,
        pickListValue: "",
      };

      let result = this.quoctichs.filter((x) => x.used == true);
      result.unshift(null_value);
      return result;
    },
  },

  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/picklist/dantoc"),
        axios.get("/api/picklist/tongiao"),
        axios.get("/api/picklist/quoctich"),
        axios.get("/api/picklist/quanhe"),
        axios.get("/api/department"),
        axios.get("/api/location/province"),
        axios.get("/api/employee/getlinemanager"),
        axios.get("/api/picklist/tinhtranghoso"),
        axios.get("/api/bank"),
      ])
      .then(
        axios.spread(
          (
            dantoc,
            tongiao,
            quoctich,
            quanhe,
            department,
            province,
            employee,
            tinhtranghoso,
            bank
          ) => {
            next((vm) =>
              vm.initData(
                dantoc.data,
                tongiao.data,
                quoctich.data,
                quanhe.data,
                department.data,
                province.data,
                employee.data,
                tinhtranghoso.data,
                bank.data
              )
            );
          }
        )
      );
  },
  methods: {
    findFirst(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.tendonvi;
    },
    normalizer(node) {
      if (node.childs != null) {
        return {
          id: node.id,
          label: node.tendonvi,
          children: node.childs,
        };
      } else {
        return {
          id: node.id,
          label: node.tendonvi,
        };
      }
    },
    initData(
      dantocs,
      tongiaos,
      quoctichs,
      quanhes,
      departments,
      provinces,
      employees,
      tinhtranghosos,
      banks
    ) {
      this.dantocs = dantocs;
      this.tongiaos = tongiaos;
      this.quoctichs = quoctichs;
      this.quanhes = quanhes;
      this.departments = departments;
      this.provinces = provinces;
      this.hiennay_provinces = provinces;
      this.hopitalCityProvinces = provinces;
      this.employees = employees;
      this.tinhtranghosos = tinhtranghosos;
      this.banks = banks;

      this.thong_tin_chung.tinhtranghoso = this.tinhtranghosos[0].id; // Trạng thái mặc định là đang làm việc
    },
    openModal() {
      this.modalShow = true;
      this.modalItems = this.quoctichs;
    },

    openChildModal() {
      this.itemModalName = null;
      this.itemModalUsed = true;
      this.childModalShow = true;
    },

    fileChange(fieldName, fileList) {
      if (!fileList.length) return;
      this.isImageUploading = true;
      const formData = new FormData();
      formData.append("file", fileList[0]);
      axios
        .post("/api/employee/uploadimage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.thong_tin_chung.anhnhanvien = res.data.filename;
          this.thong_tin_chung.anhnhanvienpath = res.data.filepath;
          this.isImageUploading = false;
          this.uploadImageShow = false;
        })
        .catch((err) => {
          alert(err);
        });
    },
    clearItemImage() {
      this.thong_tin_chung.anhnhanvien = this.thong_tin_chung.anhnhanvienpath = null;
    },
    // updateItem() {
    //   if (
    //     !(
    //       this.thong_tin_chung.manhanvien &&
    //       this.thong_tin_chung.manhanvien.length
    //     ) ||
    //     !(this.thong_tin_chung.hovaten && this.thong_tin_chung.hovaten.length)
    //   ) {
    //     this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
    //       timeout: 2000,
    //     });
    //   } else {
    //     axios
    //       .put("/api/employee", this.thong_tin_chung)
    //       .then((res) => {
    //         this.$emit("update", this.thong_tin_chung);
    //         this.$toast.success("Cập nhật thành công !", "Thành công", {
    //           timeout: 2000,
    //         });
    //       })
    //       .catch((err) => {
    //         this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
    //       });
    //   }
    // },

    goBack() {
      // this.$router.go(-1);
      this.$router.push(`/hr_record?status=0`);
    },

    storeItem() {
      var reg_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (
        !(this.thong_tin_chung.email && this.thong_tin_chung.email.length) ||
        !(
          this.thong_tin_chung.manhanvien &&
          this.thong_tin_chung.manhanvien.length
        ) ||
        !(this.thong_tin_chung.hovaten && this.thong_tin_chung.hovaten.length)
      ) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
      } else if (!reg_email.test(this.thong_tin_chung.email)) {
        this.$toast.error("Email không đúng định dạng", "Lỗi", {
          timeout: 2000,
        });
      } else if (!this.employee_group.employeeid2 && !this.noLinemanager) {
        this.$toast.error("Vui lòng chọn Line Manager", "Lỗi", {
          timeout: 2000,
        });
      } else {
        if (this.employee_group.ccemail != null) {
          var ccemail_err = this.CheckCCEmail(
            this.employee_group.ccemail.trim().trim(",")
          );
          if (ccemail_err != "") {
            this.$toast.error(
              `CC Email mục Line Manager không đúng định dạng [${ccemail_err}]`,
              "Lỗi",
              {
                timeout: 2000,
              }
            );
            return;
          }
        }

        if (this.hokhau_tinhthanhpho_selected != null)
          this.thong_tin_lien_he.hokhau_tinhthanhpho =
            "" + this.hokhau_tinhthanhpho_selected.id;
        if (this.hokhau_quanhuyen_selected != null)
          this.thong_tin_lien_he.hokhau_quanhuyen =
            "" + this.hokhau_quanhuyen_selected.id;
        if (this.hokhau_xaphuong_selected != null)
          this.thong_tin_lien_he.hokhau_xaphuong =
            "" + this.hokhau_xaphuong_selected.id;

        if (this.hiennay_tinhthanhpho_selected != null)
          this.thong_tin_lien_he.hiennay_tinhthanhpho =
            "" + this.hiennay_tinhthanhpho_selected.id;
        if (this.hiennay_quanhuyen_selected != null)
          this.thong_tin_lien_he.hiennay_quanhuyen =
            "" + this.hiennay_quanhuyen_selected.id;
        if (this.hiennay_xaphuong_selected != null)
          this.thong_tin_lien_he.hiennay_xaphuong =
            "" + this.hiennay_xaphuong_selected.id;

        if (this.hopital_city_selected != null)
          this.thong_tin_chung.hopitalCity = "" + this.hopital_city_selected.id;
        else this.thong_tin_chung.hopitalCity = null;

        if (this.cbx_hien_nay_giong_ho_khau)
          this.thong_tin_lien_he.hiennay_tinhthanhpho = "copy";

        this.thong_tin_chung.ngaysinh = this.$convert_string_date(
          this.ngaysinh_selected
        );
        this.thong_tin_chung.cmndngaycap = this.$convert_string_date(
          this.cmndngaycap_selected
        );
        this.thong_tin_chung.cmndngayhethan = this.$convert_string_date(
          this.cmndngayhethan_selected
        );

        //#region Add Line Manager
        this.employee_group.employeeid = this.thong_tin_chung.id;
        this.thong_tin_chung.employeeGroup = this.employee_group;
        //#endregion
        const payload = {
          noLiMngr: this.noLinemanager,
          employee: this.thong_tin_chung,
          employeecontact: this.thong_tin_lien_he,
        };
        axios
          .post("/api/employee", payload)
          .then((res) => {
            this.goBack();
            //thong_tin_lien_he.employeeid = res.data
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
          });
      }
    },

    CheckCCEmail(ccemail) {
      var reg_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var ccemail_arr = ccemail.split(",");
      var ccemail_err = "";
      ccemail_arr.forEach((element) => {
        if (!reg_email.test(element)) ccemail_err += element + ", ";
      });
      return ccemail_err.trim().trim(",");
    },

    findDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });

      return temp.madonvi;
    },

    autogenerateUserCode() {
      const department_code = this.findDepartment(
        this.departments,
        this.departmentCode
      );

      var last = "";

      for (var el of this.employees) {
        var employee_number = el.manhanvien.slice(-3);
        var employee_code = el.manhanvien.replace(employee_number, "");
        if (employee_code == department_code) last = employee_number;
      }
      if (last == "") last = "001";
      else if (last != "") {
        last = parseInt(last) + 1;
        if (last % 10 == last) {
          last = "00" + last;
        } else if (last % 100 == last) {
          last = "0" + last;
        }
      }

      this.thong_tin_chung.manhanvien = department_code + last;
    },

    //#region line manager
    unlockLineManager(linemanager) {
      this.linemanager_selected = null;
      // this.employee_group.ccemail = "hr@megroup.asia";
      this.ccEmailEnabled = true;
    },
    lockLineManager() {
      this.linemanager_selected = null;
      this.employee_group.ccemail = null;
      this.ccEmailEnabled = false;
    },
    changeLinemanager() {
      if (this.noLinemanager) {
        /*Create employees requires line managers*/ this.linemanager_selected = this.linemanager_temp_selected;
        this.lineManagerEnabled = true;
        if (this.linemanager_selected) this.ccEmailEnabled = true;
        else this.ccEmailEnabled = false;
      } /*Create employees without line managers*/ else {
        this.linemanager_temp_selected = this.linemanager_selected;
        this.linemanager_selected = null;
        this.lineManagerEnabled = false;
        this.ccEmailEnabled = false;
      }
    },
    //#endregion

    //#region hopital city
    unlockHopitalCity(city) {
      this.hopital_city_selected = null;
      this.thong_tin_chung.hopitalBranch = null;
      this.hopitalBranchEnabled = true;
    },
    lockHopitalCity() {
      this.hopital_city_selected = null;
      this.hopitalBranchEnabled = false;
    },
    //#endregion

    //#region Ho khau
    unlockDistrict(city) {
      this.hokhau_quanhuyen_selected = null;
      this.lockWard();

      axios
        .get(`/api/location/district/${city.id}`)
        .then((res) => {
          this.districts = res.data;
          this.districtEnabled = true;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },

    unlockWard(district) {
      this.hokhau_xaphuong_selected = null;
      axios
        .get(`/api/location/ward/${district.id}`)
        .then((res) => {
          this.wards = res.data;
          this.wardEnabled = true;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },

    lockDistrictAndWard() {
      this.hokhau_quanhuyen_selected = null;
      this.hokhau_xaphuong_selected = null;
      this.districtEnabled = false;
      this.wardEnabled = false;
    },

    lockWard() {
      this.hokhau_xaphuong_selected = null;
      this.wardEnabled = false;
    },
    //#endregion

    //#region dia chi hien nay
    unlockDistrict_hiennay(city) {
      this.hiennay_hokhau_quanhuyen_selected = null;
      this.lockWard_hiennay();

      axios
        .get(`/api/location/district/${city.id}`)
        .then((res) => {
          this.hiennay_districts = res.data;
          this.hiennay_districtEnabled = true;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },

    unlockWard_hiennay(district) {
      this.hiennay_hokhau_xaphuong_selected = null;
      axios
        .get(`/api/location/ward/${district.id}`)
        .then((res) => {
          this.hiennay_wards = res.data;
          this.hiennay_wardEnabled = true;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },

    lockDistrictAndWard_hiennay() {
      this.hiennay_hokhau_quanhuyen_selected = null;
      this.hiennay_hokhau_xaphuong_selected = null;
      this.hiennay_districtEnabled = false;
      this.hiennay_wardEnabled = false;
    },

    lockWard_hiennay() {
      this.hiennay_hokhau_xaphuong_selected = null;
      this.hiennay_wardEnabled = false;
    },
    //#endregion

    copySlot() {
      if (!this.cbx_hien_nay_giong_ho_khau) {
        this.hiennay_tinhthanhpho_selected = this.hokhau_tinhthanhpho_selected;
        this.hiennay_quanhuyen_selected = this.hokhau_quanhuyen_selected;
        this.hiennay_xaphuong_selected = this.hokhau_xaphuong_selected;
        this.thong_tin_lien_he.hiennay_sonha = this.thong_tin_lien_he.hokhau_sonha;
      } else {
        this.hiennay_tinhthanhpho_selected = null;
        this.hiennay_quanhuyen_selected = null;
        this.hiennay_xaphuong_selected = null;
        this.thong_tin_lien_he.hiennay_sonha = null;
      }
    },

    storeModalItem(bvModalEvt) {
      if (!(this.itemModalName && this.itemModalName.length)) {
        this.$toast.error("Vui lòng nhập tên !", "Lỗi", { timeout: 3000 });
        bvModalEvt.preventDefault();
      } else {
        var isItemExist = this.modalItems.filter(
          (item) =>
            item.pickListValue.toLowerCase() ===
            this.itemModalName.toLowerCase()
        );
        if (isItemExist.length > 0) {
          this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 2000 });
          bvModalEvt.preventDefault();
        } else {
          axios
            .post("/api/picklist", {
              picklisttype: this.modalType,
              picklistvalue: this.itemModalName,
              sortorder: 99,
              used: this.itemModalUsed,
            })
            .then((res) => {
              this.modalItems.push(res.data);
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
            });
        }
      }
    },

    updateModalItem(data, event) {
      var new_item_name = event.target.value;
      if (!(new_item_name && new_item_name.length)) {
        this.$toast.error("Vui lòng nhập tên !", "Lỗi", { timeout: 3000 });
        event.target.value = data.item.pickListValue;
      } else {
        var isItemExist = this.modalItems.filter(
          (item) =>
            item.pickListValue.toLowerCase() === new_item_name.toLowerCase() &&
            item.id != data.item.id
        );
        if (isItemExist.length > 0) {
          this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 2000 });
          event.target.value = data.item.pickListValue;
        } else {
          axios
            .put("/api/picklist", {
              id: data.item.id,
              name: new_item_name,
            })
            .then((res) => {
              this.$toast.success("Cập nhật thành công !", "Thành công", {
                timeout: 3000,
              });
              this.modalItems[data.index].pickListValue = new_item_name;
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
              event.target.value = data.item.name;
            });
        }
      }
    },

    updateUsedModalItem(data) {
      axios
        .put("/api/picklist/used", {
          id: data.item.id,
          used: data.item.used,
        })
        .then((res) => {
          this.$toast.success("Cập nhật thành công !", "Thành công", {
            timeout: 3000,
          });
          this.modalItems[data.index].used = data.item.used;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
          event.target.value = data.item.name;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.file-uploads {
  overflow: hidden;
  position: relative;
  text-align: center;
  display: inline-block;
}

.file-uploads.file-uploads-html4 input,
.file-uploads.file-uploads-html5 label {
  background: #fff;
  opacity: 0;
  font-size: 20em;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  height: 100%;
}

.file-uploads.file-uploads-html4 label,
.file-uploads.file-uploads-html5 input {
  background: rgba(255, 255, 255, 0);
  overflow: hidden;
  position: fixed;
  width: 1px;
  height: 1px;
  z-index: -1;
  opacity: 0;
}
</style>
<style>
#employee_fluid .multiselect--disabled .multiselect__tags {
  background: #e9ecef;
}
#employee_fluid div.multiselect--disabled {
  opacity: 1;
}
</style>
